import React from 'react';
import { Button } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

interface Props {
  onNewSession: () => void;
}

const MessageSessionExpired: React.FC<Props> = ({ onNewSession }) => (
  <div className="uzy-tool-card" style={{ borderColor: '#ffbb96' }}>
    <div className="uzy-tool-card-header" style={{ background: '#fff2e8', borderBottomColor: '#ffbb96', color: '#d4380d' }}>
      <ClockCircleOutlined style={{ marginRight: 6 }} />会话已过期
    </div>
    <div className="uzy-tool-card-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
      <span>当前会话已过期，请重新创建会话。</span>
      <Button size="small" type="primary" onClick={onNewSession}>新会话</Button>
    </div>
  </div>
);

export default MessageSessionExpired;
